import React from 'react'
import { connect } from 'react-redux'
import {
  handleFireflySendEvent,
  handleFireflySendClickEvent,
} from '../Utils/FireFlyVnextHelpers'
import {
  getCablingCounts,
  clearCablingCountsStatusMessage,
} from '../../store/Cabling/actionCreator'
import MrtReusableTable from '../Utils/MrtReusableTable'
import {
  FormControl,
  Grid,
  Typography,
  CardActions,
  CardContent,
  TextareaAutosize,
  Button,
} from '@mui/material'
import SuccessModal from './SuccessModal'

const locationsAndCablesColumns = [
  {
    accessorKey: 'location',
    header: 'Location Id',
  },
  {
    accessorKey: 'blackCables',
    header: 'Black Cables',
  },
  {
    accessorKey: 'blueCables',
    header: 'Blue Cables',
  },
  {
    accessorKey: 'yellowCables',
    header: 'Yellow Cables',
  },
]
const defaultColumns = ['location', 'blackCables', 'blueCables', 'yellowCables']

export class PatchCableCountsTab extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      buttonEnabled: false,
      cablingCounts: [],
      cablingCountsStatusMessage: '',
      statusOpen: false,
      locationIds: [],
    }
    this.handleOnSubmit = this.handleOnSubmit.bind(this)
    this.handleStatusClose = this.handleStatusClose.bind(this)
    this.resetForm = this.resetForm.bind(this)
  }

  async componentDidMount() {
    const { userInfo } = this.props
    if (userInfo.email !== '') {
      handleFireflySendEvent(
        'PAGE_VIEW',
        'Patch Cable Counts Tab',
        'Patch Cable Counts Tab Load',
        userInfo,
      )
    }
  }

  static defaultProps = {
    userInfo: {
      email: undefined,
    },
  }

  componentDidUpdate(prevProps) {
    if (this.props.cablingCounts !== prevProps.cablingCounts) {
      this.setState({
        cablingCounts: this.props.cablingCounts,
      })
    }
    if (
      this.props.cablingCountsStatusMessage !==
      prevProps.cablingCountsStatusMessage
    ) {
      this.setState({
        cablingCountsStatusMessage: this.props.cablingCountsStatusMessage,
      })
    }
  }

  handleOnSubmit(event) {
    const { userInfo } = this.props
    handleFireflySendClickEvent(
      'CLICK',
      'Patch Cable Counts Tab',
      'Patch Cable Counts - Create',
      userInfo,
    )
    event.preventDefault()
    const locationIds = this.state.locationIds
      .split(/[\s,]+/)
      .filter((id) => id.trim() !== '')
    this.props.getCablingCounts(locationIds)
    this.setState({ statusOpen: true })
    this.resetForm()
  }

  handleStatusClose() {
    this.setState({
      statusOpen: false,
    })
    this.props.clearCablingCountsStatusMessage()
  }

  resetForm() {
    this.setState({
      locationIds: [],
      cablingCounts: [],
      buttonEnabled: false,
    })
  }

  validateForm = () => {
    const buttonEnabled =
      this.state.locationIds.split(/[\s,]+/).filter((id) => id.trim() !== '')
        .length > 0
    if (this.state.buttonEnabled !== buttonEnabled) {
      this.setState({ buttonEnabled })
    }
  }

  render() {
    const modalTitle =
      this.state.cablingCountsStatusMessage === ''
        ? ''
        : this.state.cablingCountsStatusMessage.includes('Success')
          ? 'Success'
          : 'Failed'

    return (
      <CardContent
        style={{
          height: '90%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          overflowY: 'auto',
        }}
      >
        <CardActions style={{ width: '100%' }}>
          <Grid
            item
            size={{ xs: 12 }}
            style={{
              marginTop: 0,
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography gutterBottom sx={{ fontSize: '16px' }}>
              Enter locations to calculate patch cables to order.
            </Typography>
            <br />
            <br />
          </Grid>
        </CardActions>
        <form onSubmit={this.handleOnSubmit}>
          <Grid
            container
            style={{
              width: '100%',
              height: '100%',
              alignItems: 'stretch',
              display: 'flex',
            }}
          >
            <Grid container item style={{ paddingLeft: 8, width: '100%' }}>
              <FormControl component="fieldset" style={{ width: '100%' }}>
                <Grid item size={{ xs: 12, md: 8 }}>
                  <TextareaAutosize
                    htmlFor="locationIds"
                    type="text"
                    minRows={10}
                    maxRows={18}
                    value={this.state.locationIds}
                    placeholder="Enter Locations (Ex: T0003 T0004 ETC)"
                    label="Locations"
                    required
                    onChange={(event) => {
                      this.setState({ locationIds: event.target.value }, () => {
                        this.validateForm()
                      })
                    }}
                    style={{ width: '100%' }}
                  />
                </Grid>
                <br />
                <Grid item size={{ xs: 12, md: 6 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={!this.state.buttonEnabled}
                  >
                    Submit
                  </Button>
                </Grid>
              </FormControl>
            </Grid>
          </Grid>
        </form>
        <br></br>
        <MrtReusableTable
          pageTitle="Locations and Cables"
          columns={locationsAndCablesColumns}
          defaultColumns={defaultColumns}
          rowData={this.props.cablingCounts}
          loading={this.state.loading}
          loadingMessage="Loading Patch Cabling Counts..."
          pageSize={[10, 20, 50]}
          style={{ zIndex: 0 }}
        />
        <SuccessModal
          open={this.state.statusOpen}
          handleClose={this.handleStatusClose}
          title={modalTitle}
          eventMessage={this.state.cablingCountsStatusMessage}
        />
      </CardContent>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    cablingCounts: state.cabling.cablingCounts,
    cablingCountsStatusMessage: state.cabling.cablingCountsStatusMessage,
    userInfo: state.auth.userInfo,
  }
}

const mapDispatchToProps = {
  clearCablingCountsStatusMessage,
  getCablingCounts,
}

export default connect(mapStateToProps, mapDispatchToProps)(PatchCableCountsTab)
